import React, { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";
import { BrandWrapper, BrandImageWrapper, BrandName } from "./Brand.style";

const Partner = ({
  item,
  handleSelection,
  homePage = false,
  className = "",
  withShadow = true
}) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <BrandWrapper style={{ border: "none" }} onClick={handleSelection} withShadow={withShadow}>
      <BrandImageWrapper>
        <LazyLoad height={140}>
          <img
            src={
              item.logo !== null
                ? item.logo
                : require("../../assets/icons/delishop_logo2.svg")
            }
            className={`product-image ${className}`}
            style={{ position: "relative", height: "auto", width: "100%" }}
            alt={"Brand"}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = require("../../assets/icons/delishop_logo2.svg");
            }}
            width={"70"}
            height={"70"}
            // onLoad={() => setLoaded(true)}
            // onLoad={()=> {return <Loader />}}
          />
        </LazyLoad>
      </BrandImageWrapper>
      {!homePage && <BrandName>{item.title}</BrandName>}
    </BrandWrapper>
  );
};

export default Partner;
